// src/components/GearModal.jsx

import React from "react";
import GearForm from "./GearForm";

export default function GearModal({
  modalRef,
  gear,
  onClose,
  onSave,
  team = [],
  projects = [],
  categories = [],
  statuses = [],
  fields = [],
  isAdminOrManager = false,
  asPage = false,
}) {
  return (
    <div
      className={
        asPage
          ? "w-full"
          : "fixed inset-0 bg-black bg-opacity-30 z-40 flex items-center justify-center"
      }
    >
      <div
        ref={modalRef}
        className={
          asPage
            ? "bg-white rounded-xl shadow-none p-0 w-full"
            : "bg-white rounded-xl shadow-lg p-6 w-full max-w-md"
        }
      >
        <GearForm
          gear={gear}
          onClose={onClose}
          onSave={onSave}
          team={team}
          projects={projects}
          categories={categories}
          statuses={statuses}
          fields={fields}
          isAdminOrManager={isAdminOrManager}
          asPage={asPage}
          showTitle={true}
        />
      </div>
    </div>
  );
}
